import { render, staticRenderFns } from "./setDeviceType.vue?vue&type=template&id=59c18ea0&scope=scope"
import script from "./setDeviceType.vue?vue&type=script&lang=js"
export * from "./setDeviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports